var _circle, _circle2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbsentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.3177,
    cy: 22.4593,
    r: 22.3304,
    fill: "url(#paint0_linear_1_13971)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.3177,
    cy: 22.4593,
    r: 22.3304,
    fill: "#FCD8D5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_13971)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5837 22.4777C12.5837 19.6672 13.7002 16.9719 15.6875 14.9846C17.6748 12.9973 20.3701 11.8809 23.1805 11.8809C25.991 11.8809 28.6863 12.9973 30.6736 14.9846C32.6609 16.9719 33.7773 19.6672 33.7773 22.4777C33.7773 25.2881 32.6609 27.9834 30.6736 29.9707C28.6863 31.958 25.991 33.0745 23.1805 33.0745C20.3701 33.0745 17.6748 31.958 15.6875 29.9707C13.7002 27.9834 12.5837 25.2881 12.5837 22.4777ZM23.1805 13.4009C20.7732 13.4009 18.4645 14.3572 16.7623 16.0594C15.06 17.7616 14.1037 20.0703 14.1037 22.4777C14.1037 24.885 15.06 27.1937 16.7623 28.8959C18.4645 30.5982 20.7732 31.5545 23.1805 31.5545C25.5879 31.5545 27.8966 30.5982 29.5988 28.8959C31.301 27.1937 32.2573 24.885 32.2573 22.4777C32.2573 20.0703 31.301 17.7616 29.5988 16.0594C27.8966 14.3572 25.5879 13.4009 23.1805 13.4009ZM26.9469 18.7129C27.0969 18.8629 27.1812 19.0663 27.1812 19.2785C27.1812 19.4906 27.0969 19.694 26.9469 19.8441L24.3117 22.4777L26.9469 25.1113C27.0972 25.2615 27.1816 25.4652 27.1816 25.6777C27.1816 25.8901 27.0972 26.0938 26.9469 26.2441C26.7967 26.3943 26.593 26.4787 26.3805 26.4787C26.1681 26.4787 25.9644 26.3943 25.8141 26.2441L23.1805 23.6089L20.5469 26.2441C20.4726 26.3184 20.3843 26.3774 20.2871 26.4177C20.1899 26.458 20.0857 26.4787 19.9805 26.4787C19.8754 26.4787 19.7712 26.458 19.674 26.4177C19.5768 26.3774 19.4885 26.3184 19.4141 26.2441C19.3398 26.1697 19.2808 26.0814 19.2405 25.9842C19.2002 25.887 19.1795 25.7829 19.1795 25.6777C19.1795 25.5725 19.2002 25.4683 19.2405 25.3711C19.2808 25.2739 19.3398 25.1856 19.4141 25.1113L22.0493 22.4777L19.4141 19.8441C19.2639 19.6938 19.1795 19.4901 19.1795 19.2777C19.1795 19.0652 19.2639 18.8615 19.4141 18.7113C19.5644 18.561 19.7681 18.4766 19.9805 18.4766C20.193 18.4766 20.3967 18.561 20.5469 18.7113L23.1805 21.3465L25.8141 18.7113C25.8885 18.6368 25.9767 18.5777 26.0739 18.5373C26.1711 18.497 26.2753 18.4762 26.3805 18.4762C26.4858 18.4762 26.59 18.497 26.6872 18.5373C26.7843 18.5777 26.8726 18.6384 26.9469 18.7129Z",
    fill: "#F87168"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_13971",
    x1: 18.9302,
    y1: -1.50098,
    x2: 45.4302,
    y2: 43.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006EC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00345C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_13971"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.1917,
    height: 26.1917,
    fill: "white",
    transform: "translate(10.1804 9.47852)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbsentIcon);
export default __webpack_public_path__ + "static/media/AbsentIcon.d59c68b96e80160efe82238b135c2f14.svg";
export { ForwardRef as ReactComponent };